export const light = {
  name: 'light-theme',
  colors: {
    background: 'hsl(0, 0%, 100%)',
    dimBackground: 'hsl(0, 0%, 95%)',
    hoverTableBg: 'hsl(199, 99%, 50%)',
    hoverTableText: 'hsl(0, 0%, 100%)',
    text: 'hsl(0, 0%, 0%)',
    border: 'hsl(0, 0%, 85%)',
    rvtText: 'hsl(0, 0%, 100%)',
  },
  select: {
    text: 'hsl(0, 0%, 100%)',
    background: 'hsl(199, 99%, 50%)',
    hover: 'hsl(199, 99%, 59%)',
  },
  active: {
    text: 'hsl(0, 0%, 100%)',
    background: 'hsl(199, 99%, 50%)',
    hover: 'hsl(199, 99%, 59%)',
  },
};

export const dark = {
  name: 'dark-theme',
  colors: {
    background: 'hsl(209.3,100%,8%)',
    dimBackground: 'hsl(209.3,80%,12%)',
    hoverTableBg: 'hsl(209.3,100%,8%)',
    hoverTableText: 'hsl(0, 0%, 100%)',
    text: 'hsl(0, 0%, 100%)',
    border: 'hsl(0, 0%, 98%)',
    rvtText: 'hsl(0, 0%, 0%)',
  },
  select: {
    text: 'hsl(0, 0%, 100%)',
    background: 'hsl(199, 99%, 50%)',
    hover: 'hsl(199, 99%, 59%)',
  },
  active: {
    text: 'hsl(0, 0%, 100%)',
    background: 'hsl(199, 99%, 50%)',
    hover: 'hsl(199, 99%, 59%)',
  },
};

export const blue = {
  name: 'blue-theme',
  colors: {
    background: 'hsl(194, 100%, 90%)',
    dimBackground: 'hsl(194, 100%, 76%)',
    hoverTableBg: 'hsl(194, 100%, 86%)',
    hoverTableText: 'hsl(0, 0%, 0%)',
    text: 'hsl(0, 0%, 0%)',
    border: 'hsl(194, 100%, 80%)',
    rvtText: 'hsl(0, 0%, 100%)',
  },
  select: {
    text: 'hsl(0, 0%, 100%)',
    background: 'hsl(199, 99%, 50%)',
    hover: 'hsl(199, 99%, 59%)',
  },
  active: {
    text: 'hsl(0, 0%, 100%)',
    background: 'hsl(199, 99%, 50%)',
    hover: 'hsl(199, 99%, 59%)',
  },
};

export const green = {
  name: 'green-theme',
  colors: {
    background: 'hsl(150, 80%, 20%)',
    dimBackground: 'hsl(150, 80%, 14%)',
    hoverTableBg: 'hsl(150, 80%, 20%)',
    hoverTableText: 'hsl(150, 80%, 90%)',
    text: 'hsl(150, 80%, 90%)',
    border: 'hsl(150, 70%, 100%)',
    rvtText: 'hsl(150, 80%, 40%)',
  },
  select: {
    text: 'hsl(0, 0%, 100%)',
    background: 'hsl(199, 99%, 50%)',
    hover: 'hsl(199, 99%, 59%)',
  },
  active: {
    text: 'hsl(0, 0%, 100%)',
    background: 'hsl(199, 99%, 50%)',
    hover: 'hsl(199, 99%, 59%)',
  },
};

export const yellow = {
  name: 'yellow-theme',
  colors: {
    background: 'hsl(44, 96%, 71%)',
    dimBackground: 'hsl(42, 94%, 60%)',
    hoverTableBg: 'hsl(42, 94%, 60%)',
    hoverTableText: 'hsl(100, 0%, 20%)',
    text: 'hsl(100, 0%, 20%)',
    border: 'hsl(36, 100%, 40%)',
    rvtText: 'hsl(100, 0%, 100%)',
  },
  select: {
    text: 'hsl(0, 0%, 100%)',
    background: 'hsl(199, 99%, 50%)',
    hover: 'hsl(199, 99%, 59%)',
  },
  active: {
    text: 'hsl(0, 0%, 100%)',
    background: 'hsl(199, 99%, 50%)',
    hover: 'hsl(199, 99%, 59%)',
  },
};

// chưa dùng đến
export const brown = {
  name: 'brown-theme',
  colors: {
    background: 'hsl(43, 29%, 69%)',
    dimBackground: 'hls(43, 29%, 41%)',
    hoverTableBg: 'hsl(43, 29%, 69%)',
    hoverTableText: 'hsl(0, 0%, 100%)',
    text: 'hsl(0, 0%, 100%)',
    border: 'hls(43, 29%, 11%)',
    rvtText: 'hsl(0, 0%, 10%)',
  },
  select: {
    text: 'hsl(0, 0%, 100%)',
    background: 'hsl(199, 99%, 50%)',
    hover: 'hsl(199, 99%, 59%)',
  },
  active: {
    text: 'hsl(0, 0%, 100%)',
    background: 'hsl(199, 99%, 50%)',
    hover: 'hsl(199, 99%, 59%)',
  },
};

export const pink = {
  name: 'pink-theme',
  colors: {
    background: 'hsl(300, 80%, 88%)',
    dimBackground: 'hsl(300, 80%, 82%)',
    hoverTableBg: 'hsl(300, 80%, 88%)',
    hoverTableText: 'hsl(300, 100%, 28%)',
    text: 'hsl(300, 100%, 28%)',
    border: 'hsl(300, 50%, 58%)',
    rvtText: 'hsl(300, 100%, 98%)',
  },
  select: {
    text: 'hsl(0, 0%, 100%)',
    background: 'hsl(199, 99%, 50%)',
    hover: 'hsl(199, 99%, 59%)',
  },
  active: {
    text: 'hsl(0, 0%, 100%)',
    background: 'hsl(199, 99%, 50%)',
    hover: 'hsl(199, 99%, 59%)',
  },
};
